import { render, staticRenderFns } from "./uploadDataClass.vue?vue&type=template&id=3313fdd2"
import script from "./uploadDataClass.vue?vue&type=script&lang=js"
export * from "./uploadDataClass.vue?vue&type=script&lang=js"
import style0 from "./uploadDataClass.vue?vue&type=style&index=0&id=3313fdd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports